import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectIsInProgress } from '../../spinner/ducks';
import { normalizeString } from '../../../common/utils/helpers';
import { SmsLogsList } from '../components';
import { apiCallIds } from '../api';
import {
    fetchSmsLogsActions,
    selectSmsLogs,
    selectSmsLogsFilter,
    selectSmsLogsPagination,
    setSmsLogsFilterAction
} from '../ducks';
import Spin from 'antd/lib/spin';

const mapStateToProps = state => ({
    smsLogs: selectSmsLogs(state),
    filter: selectSmsLogsFilter(state),
    isLoading: selectIsInProgress(state, apiCallIds.FETCH_EMAIL_LOGS),
    pagination: selectSmsLogsPagination(state),
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchSmsLogs: fetchSmsLogsActions.request,
            setFilter: setSmsLogsFilterAction,
        },
        dispatch
    ),
});

const defaultFilter = {
    search: '',
    sentDateStart: '',
    sentDateEnd: ''
};

@connect(mapStateToProps, mapDispatchToProps)
export default class SmsLogsListContainer extends Component {
    static propTypes = {
        actions: PropTypes.object,
    };

    componentDidMount() {
        const { actions } = this.props;
        actions.setFilter(defaultFilter);
        actions.fetchSmsLogs(defaultFilter);
        actions.fetch
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { actions, filter } = this.props;
        actions.fetchSmsLogs({
            ...filter,
            pageNo: pagination.current - 1,
        });
    };

    onFilterChange = filterKey => filterValue => {
        const { actions, filter } = this.props;
        actions.setFilter({
            ...filter,
            [filterKey]: filterValue,
        });
    };


    onFilterDateRangeChange = ([dateFrom, dateTo]) => {
        const { actions, filter } = this.props;
        actions.setFilter({
            ...filter,
            sentDateStart: dateFrom ? dateFrom.startOf('day').toISOString() : "",
            sentDateEnd: dateTo ? dateTo.endOf('day').toISOString() : ""
        })
    };

    onFilterSearchChange = filterValue => {
        const { actions, filter } = this.props;
        actions.setFilter({
            ...filter,
            search: normalizeString(filterValue)
        });
    };
    onFilterStatusChange = this.onFilterChange('status');

    render() {
        const { smsLogs, filter, isLoading, pagination } = this.props;

        return (<div>
            {!smsLogs ?
                <Spin className="dasboard-spinner" spinning={!smsLogs}>
                    <div className="dashboard-spinner-message">{"Prebieha výpočet dát pre dashboard"}</div>
                </Spin> :

                <SmsLogsList
                    smsLogs={smsLogs}
                    filter={filter}
                    isLoading={isLoading}
                    onFilterSearchChange={this.onFilterSearchChange}
                    onFilterDateRangeChange={this.onFilterDateRangeChange}
                    onFilterStatusChange={this.onFilterStatusChange}
                    onTableChange={this.handleTableChange}
                    pagination={pagination}
                />}
        </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/features/messaging-dashboard/containers/SmsLogsListContainer.js